import React from 'react';
import { Alert } from 'componentLibrary';
import {Segment} from 'semantic-ui-react';

const DHSPrivacy = () => {
  const DHSRecordsLink = 'https://www.dhs.gov/system-records-notices-sorns';
  return (
    <Alert info header="Privacy Act Statement">
      <br />
      <Alert.Header>AUTHORITY:</Alert.Header>
      <p>
        FEMA is authorized to collect the information requested pursuant to 44 U.S.C. §
        3101; Executive Order 9397, as amended by Executive Order 13487; and 44 U.S.C. §
        3534.
      </p>
      <Alert.Header>PURPOSE(S):</Alert.Header>
      <p>
        This information is collected so that FEMA can process grant awards through the
        FEMA Grants Outcomes (GO) system.
      </p>
      <Alert.Header>ROUTINE USE(S):</Alert.Header>
      <p>
        The information on this form may be disclosed as generally permitted under 5
        U.S.C. § 552a(b) of the Privacy Act of 1974, as amended. This includes using this
        information as necessary and authorized by the routine uses published in DHS/ALL –
        004 General Information Technology Access Account Records System of Records, 77
        Fed. Reg. 70792, (Nov. 27, 2012), and upon written request, by agreement, or as
        required by law. The Department of Homeland Security’s Systems of Records notices
        may be found at{' '}
        <a href={DHSRecordsLink} target="_blank">
          {DHSRecordsLink}
        </a>
        .
      </p>
      <Alert.Header>DISCLOSURE:</Alert.Header>
      <p>
        The disclosure of information on this form is voluntary, however failure to
        provide the information requested could delay or prevent FEMA from granting access
        to FEMA GO.
      </p>
    </Alert>
  );
};

const DHSConsent = () => {
  return (
    <React.Fragment>
      <Alert info header="Department of Homeland Security (DHS) Consent">
        <p>
          You are about to access a Department of Homeland Security computer system. This
          computer system and data therein are property of the U.S. Government and
          provided for official U.S. Government information and use. There is no
          expectation of privacy when you use this computer system. The use of a password
          or any other security measure does not establish an expectation of privacy. By
          using this system, you consent to the terms set forth in this notice. You may
          not process classified national security information on this computer system.
          Access to this system is restricted to authorized users only. Unauthorized
          access, use, or modification of this system or of data contained herein, or in
          transit to/from this system, may constitute a violation of section 1030 of title
          18 of the U.S. Code and other criminal laws. Anyone who accesses a Federal
          computer system without authorization or exceeds access authority, or obtains,
          alters, damages, destroys, or discloses information, or prevents authorized use
          of information on the computer system, may be subject to penalties, fines or
          imprisonment. This computer system and any related equipment is subject to
          monitoring for administrative oversight, law enforcement, criminal investigative
          purposes, inquiries into alleged wrongdoing or misuse, and to ensure proper
          performance of applicable security features and procedures. DHS may conduct
          monitoring activities without further notice.
        </p>
      </Alert>
    </React.Fragment>
  );
};

const DHSInfo = (consent, privacy) => {
  return (
    <React.Fragment>
      {consent && DHSConsent()}
      {privacy && DHSPrivacy()}
    </React.Fragment>
  );
};

export default DHSInfo;
